<admin-app-header></admin-app-header>

<div class="campaigns-page">
    <div class="container-fluid">
        <!-- Page Header -->
        <div class="page-header">
            <h1>Campaigns</h1>
            <div class="page-header__actions">
                <button class="btn btn-secondary" (click)="showSourceLinksHelp()"><i class="fa-solid fa-link"></i> Source Links</button>
                <button class="btn btn-primary" (click)="createCampaign()"><i class="fa-solid fa-plus"></i> New Campaign</button>
            </div>
        </div>

        <!-- Summary Stats -->
        <div class="stats-grid">
            <div class="stat-card stat-card--blue">
                <div class="stat-card__icon">
                    <i class="fa-solid fa-flag"></i>
                </div>
                <div class="stat-card__content">
                    <span class="stat-card__label">Active Campaigns</span>
                    <span class="stat-card__value">{{ getActiveCampaignsCount() }}</span>
                </div>
            </div>
            <div class="stat-card stat-card--green">
                <div class="stat-card__icon">
                    <i class="fa-solid fa-coins"></i>
                </div>
                <div class="stat-card__content">
                    <span class="stat-card__label">Paid Revenue</span>
                    <span class="stat-card__value">R {{ getTotalCampaignRevenue() | number: '1.0-0' }}</span>
                </div>
            </div>
            <div class="stat-card stat-card--purple">
                <div class="stat-card__icon">
                    <i class="fa-solid fa-layer-group"></i>
                </div>
                <div class="stat-card__content">
                    <span class="stat-card__label">Sources</span>
                    <span class="stat-card__value">{{ getUniqueSourcesCount() }}</span>
                </div>
            </div>
            <div class="stat-card stat-card--teal">
                <div class="stat-card__icon">
                    <i class="fa-solid fa-archive"></i>
                </div>
                <div class="stat-card__content">
                    <span class="stat-card__label">Archived</span>
                    <span class="stat-card__value">{{ getArchivedCampaignsCount() }}</span>
                </div>
            </div>
        </div>

        <!-- Filter Bar -->
        <div class="filter-bar">
            <div class="status-toggle">
                <button class="toggle-btn" [class.active]="statusFilter === 'active'" (click)="changeStatusFilter('active')"><i class="fa-solid fa-check-circle"></i> Active</button>
                <button class="toggle-btn" [class.active]="statusFilter === 'deleted'" (click)="changeStatusFilter('deleted')"><i class="fa-solid fa-archive"></i> Archived</button>
            </div>
        </div>

        <!-- Loading State -->
        <div class="loading-state" *ngIf="loading">
            <i class="fa-solid fa-spinner fa-spin"></i>
            <p>Loading campaigns...</p>
        </div>

        <!-- Empty State -->
        <div class="empty-state" *ngIf="!loading && filteredCampaignsByStatus.length === 0">
            <i class="fa-solid fa-flag"></i>
            <h3 *ngIf="statusFilter === 'active'">No active campaigns</h3>
            <h3 *ngIf="statusFilter === 'deleted'">No archived campaigns</h3>
            <p *ngIf="statusFilter === 'active'">Create your first campaign to start tracking your marketing efforts.</p>
            <p *ngIf="statusFilter === 'deleted'">Archived campaigns will appear here.</p>
            <button class="btn btn-primary" *ngIf="statusFilter === 'active'" (click)="createCampaign()"><i class="fa-solid fa-plus"></i> Create Campaign</button>
        </div>

        <!-- Campaigns Table -->
        <div class="table-card" *ngIf="!loading && filteredCampaignsByStatus.length > 0">
            <table class="campaigns-table">
                <thead>
                    <tr>
                        <th>Campaign</th>
                        <th>Source</th>
                        <th title="Paid invoices, VAT incl.">Paid Revenue</th>
                        <th title="Contract value of subscriptions that started, VAT incl.">Booked Value</th>
                        <th>Lead</th>
                        <th>Created</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let campaign of filteredCampaignsByStatus" (contextmenu)="onCampaignContextMenu($event, campaign)" class="campaign-row">
                        <td>
                            <div class="campaign-name">
                                <span class="name">{{ campaign.campaignName }}</span>
                                <span class="description" *ngIf="campaign.description">{{ campaign.description | slice: 0:60 }}{{ campaign.description.length > 60 ? '...' : '' }}</span>
                            </div>
                        </td>
                        <td>
                            <span class="source-badge">{{ campaign.source }}</span>
                        </td>
                        <td>
                            <span class="value-display">R {{ getCampaignRevenue(campaign.campaignName) | number: '1.2-2' }}</span>
                        </td>
                        <td>
                            <span class="value-display">R {{ getCampaignValue(campaign.campaignName) | number: '1.2-2' }}</span>
                        </td>
                        <td>
                            <span *ngIf="campaign.leadUser" class="lead-badge">{{ campaign.leadUser }}</span>
                            <span *ngIf="!campaign.leadUser" class="text-muted">—</span>
                        </td>
                        <td>
                            <span class="date-text" *ngIf="campaign.createdAt">{{ campaign.createdAt.toDate() | date: 'mediumDate' }}</span>
                        </td>
                        <td>
                            <div class="action-buttons" *ngIf="statusFilter === 'active'">
                                <button class="action-btn action-btn--share" (click)="openShareModal(campaign)" data-tooltip="Share">
                                    <i class="fa-solid fa-share-nodes"></i>
                                </button>
                                <button class="action-btn action-btn--stats" (click)="viewInReporting(campaign)" data-tooltip="View Stats">
                                    <i class="fa-solid fa-chart-column"></i>
                                </button>
                                <button class="action-btn action-btn--archive" (click)="softDeleteCampaign(campaign)" data-tooltip="Archive">
                                    <i class="fa-solid fa-box-archive"></i>
                                </button>
                            </div>
                            <div class="action-buttons" *ngIf="statusFilter === 'deleted'">
                                <button class="action-btn action-btn--stats" (click)="viewInReporting(campaign)" data-tooltip="View Stats">
                                    <i class="fa-solid fa-chart-column"></i>
                                </button>
                                <button class="action-btn action-btn--restore" (click)="restoreCampaign(campaign)" data-tooltip="Restore">
                                    <i class="fa-solid fa-rotate-left"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>

<!-- Share Modal -->
<div class="modal-overlay" *ngIf="showShareModal && selectedCampaign" (click)="closeShareModal()">
    <div class="modal-card" (click)="$event.stopPropagation()">
        <div class="modal-header">
            <h2><i class="fa-solid fa-share-nodes"></i> Share Campaign</h2>
            <button class="modal-close" (click)="closeShareModal()">
                <i class="fa-solid fa-xmark"></i>
            </button>
        </div>
        <div class="modal-body">
            <div class="campaign-info">
                <span class="source-badge">{{ selectedCampaign.source }}</span>
                <h3>{{ selectedCampaign.campaignName }}</h3>
            </div>

            <!-- Campaign URL -->
            <div class="url-section">
                <label>Campaign URL</label>
                <div class="url-input-group">
                    <input type="text" [value]="selectedCampaign.getFullUrl(baseUrl)" readonly />
                    <button class="copy-btn" (click)="copyLink()">
                        <i class="fa-solid fa-copy"></i>
                    </button>
                </div>
            </div>

            <!-- QR Code -->
            <div class="qr-section">
                <qrcode [qrdata]="selectedCampaign.getFullUrl(baseUrl)" [width]="200" [errorCorrectionLevel]="'M'" [elementType]="'svg'"></qrcode>
            </div>

            <!-- Share Options -->
            <div class="share-grid">
                <button class="share-btn share-btn--copy" (click)="copyLink()"><i class="fa-solid fa-link"></i> Copy Link</button>
                <button class="share-btn share-btn--qr" (click)="downloadQRCodeFromShare()"><i class="fa-solid fa-qrcode"></i> Download QR</button>
                <button class="share-btn share-btn--whatsapp" (click)="shareViaWhatsApp()"><i class="fa-brands fa-whatsapp"></i> WhatsApp</button>
                <button class="share-btn share-btn--email" (click)="shareViaEmail()"><i class="fa-solid fa-envelope"></i> Email</button>
            </div>
        </div>
    </div>
</div>

<!-- Generic Source Links Modal -->
<div class="modal-overlay" *ngIf="showSourceLinksModal" (click)="closeSourceLinksModal()">
    <div class="modal-card modal-card--wide" (click)="$event.stopPropagation()">
        <div class="modal-header">
            <h2><i class="fa-solid fa-link"></i> Generic Source Links</h2>
            <button class="modal-close" (click)="closeSourceLinksModal()">
                <i class="fa-solid fa-xmark"></i>
            </button>
        </div>
        <div class="modal-body">
            <p class="modal-description">
                Use these generic links to track traffic from a source without a specific campaign. Useful for social media posts, general promotions, or when you want to track overall source
                performance.
            </p>

            <div class="source-links-list">
                <div class="source-link-item" *ngFor="let source of campaignSources">
                    <span class="source-badge">{{ source }}</span>
                    <span class="source-url">{{ getSourceLink(source) }}</span>
                    <button class="copy-btn" (click)="copySourceLink(source)">
                        <i class="fa-solid fa-copy"></i>
                    </button>
                </div>
            </div>

            <div class="tip-box">
                <i class="fa-solid fa-lightbulb"></i>
                <p><strong>Tip:</strong> For campaign-specific tracking with additional details like lead assignment, create a dedicated campaign instead.</p>
            </div>
        </div>
    </div>
</div>
